import {
	ExposureConfigurationResponse,
	FieldConfiguration,
} from '../../../api/ConfigApi';
import { EndorsementExposureUpdateRequest } from '../../../types/endorsements';
import {
	Exposure,
	FieldGroupsByLocatorMap,
	FieldValuesMap,
	Peril,
	PerilCharacteristics,
} from '../../../types/policy';
import { RenewalExposureUpdateRequest } from '../../../types/renewals';
import {
	getPerilConfigFromExposureConfig,
	getUpdatedPerilFromUpdatedExposure,
	removeLimitsFromPerilConfig,
} from '../../../util/util';
import {
	consolidateFieldGroupsByLocator,
	getPerilCharacteristicsRequired,
	mergePerilUpdateObjectAndPerilCharacteristics,
	removePendingRemoveFieldGroupsLocatorsFromFieldValues,
} from '../../policy/util_sharedEndorsementAndRenewal';
import { FormBuilder } from '../types';
import { getPerilFields } from '../utils';
import getDefaultPerilValues from './getDefaultPerilValues';

const getEndorsementRenewalExposureExistingPerilForm = (
	selectedPeril: Peril,
	exposure: Exposure,
	exposureUpdateObj:
		| EndorsementExposureUpdateRequest
		| RenewalExposureUpdateRequest,
	currentExposureConfiguration: ExposureConfigurationResponse,
	currency: string,
	startTimestamp: string,
	hidePerilLimitsEnabled: boolean,
) => {
	const perilUpdateObj = getUpdatedPerilFromUpdatedExposure(
		exposureUpdateObj,
		selectedPeril.locator,
	);
	let currentPerilConfiguration = getPerilConfigFromExposureConfig(
		currentExposureConfiguration,
		selectedPeril,
	);
	// Remove limit fields from peril config if FF is enabled
	if (hidePerilLimitsEnabled) {
		currentPerilConfiguration = removeLimitsFromPerilConfig(
			currentPerilConfiguration,
		);
	}
	const currentPerilCharacteristics =
		getPerilCharacteristicsRequired(selectedPeril, startTimestamp) ||
		({} as PerilCharacteristics);
	const fields = [...currentPerilConfiguration.fields] as FieldConfiguration[];
	const fieldGroupsByLocator = consolidateFieldGroupsByLocator(
		{ ...(currentPerilCharacteristics.fieldGroupsByLocator || {}) },
		perilUpdateObj.updateFieldGroups,
		perilUpdateObj.removeFieldGroups,
	) as FieldGroupsByLocatorMap;
	const mediaByLocator = currentPerilCharacteristics.mediaByLocator;
	const perilFieldValues = currentPerilCharacteristics.fieldValues;
	const pendingFieldValues = perilUpdateObj.fieldValues;
	const originalFieldValues = perilFieldValues;

	const addFieldGroups = perilUpdateObj.addFieldGroups
		? [...perilUpdateObj.addFieldGroups]
		: [];
	const removeFieldGroup = perilUpdateObj.removeFieldGroups
		? [...perilUpdateObj.removeFieldGroups]
		: [];
	const fieldValues = removePendingRemoveFieldGroupsLocatorsFromFieldValues(
		removeFieldGroup,
		{ ...originalFieldValues, ...pendingFieldValues },
	);

	let values = {
		...fieldValues,
	} as FieldValuesMap;

	// If limits are shown, get default values and append limits fields before fieldValues
	if (!hidePerilLimitsEnabled) {
		const mergedPerilIndemnityValues =
			mergePerilUpdateObjectAndPerilCharacteristics(perilUpdateObj, {
				...currentPerilCharacteristics,
			});
		const indemnityValues = getDefaultPerilValues(mergedPerilIndemnityValues);

		values = {
			...indemnityValues,
			...values,
		} as FieldValuesMap;

		if (fields.length > 0) {
			fields[0].newline = true;
		}

		fields.unshift(...getPerilFields(currency));
	}

	const perilForm = {
		fields,
		fieldGroupsByLocator,
		values,
		mediaByLocator,
		addFieldGroups,
		removeFieldGroup,
	} as FormBuilder;

	return perilForm;
};

export default getEndorsementRenewalExposureExistingPerilForm;
